// @ts-strict-ignore
import { Fragment } from 'react';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { months } from 'src/utils/date';
import Card from 'src/components/card';
import { titleSmall } from 'styles-js/mixins/typography';

export default function CommunityPostsArchive(): JSX.Element {
  const { slug } = useSelector(({ context }) => context.currentCommunity);
  const { sidebarModuleData = [] } = useSelector(({ pages }) => pages.communityPosts?.archive);
  if (sidebarModuleData?.length === 0) return null;

  return (
    <Card title={i18n.t('Archive')}>
      {sidebarModuleData.map((item) => (
        <div className="sidebar__list" key={item.year}>
          <Year data-testid="archive-year">{item.year}</Year>
          <div>
            {months.map(month => {
              const currentMonth = item.months.find(monthNumber => month.number === monthNumber);
              return (
                <Fragment key={month.number}>
                  {currentMonth ? (
                    <Month href={`/${slug}/posts/archive/${item.year}/${month.twoDigits}?page=1`}>
                      {month.name.slice(0, 3)}
                    </Month>
                  ) : (
                    <MonthDisabled as="div">
                      {month.name.slice(0, 3)}
                    </MonthDisabled>
                  )}
                </Fragment>
              );
            })}
          </div>
        </div>
      ))}
    </Card>
  );
}

const Year = styled.div`
  ${titleSmall}
`;
const Month = styled.a`
  ${titleSmall}
  display: inline-block;
  width: 56px;
  height: 40px;
  margin: 8px 4px 0 4px;
  border: ${({ theme }) => theme.greyLine};
  color: ${({ theme }) => theme.colorBlack};
  text-transform: uppercase;
  text-align: center;
  font-size: 13px;
  line-height: 40px;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colorBlueBackground};
  }

  @media (${({ theme }) => theme.underScreenIpad}) {
    width: 48px;
  }
`;
const MonthDisabled = styled(Month)`
  color: ${({ theme }) => theme.colorBlack};
  background-color: ${({ theme }) => theme.colorGreyLight};
  cursor: default;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colorBlack};
    background-color: ${({ theme }) => theme.colorGreyLight};
  }
`;
